import Home from "../../components/features/home/Home";

const HomePage = () => {
  return <Home />;
};

export default HomePage;
